module.exports = __webpack_public_path__ + "img/big-AI-icon.259e0446.svg";